import classNames from 'classnames'
import * as React from 'react'

import { RedGreenText } from '../../components/RedGreenText'
import { TableAlign } from '../../components/Table'
import { shortFormatNumber } from '../../util'
import { RevenueColumnsType, RevenueDataEnum } from './types'

const getColumns = (yearKeys: string[]) => {
  const commonClassName = 'w-22 last:w-29.5 px-4 last:pr-11'

  const columns: RevenueColumnsType['columns'] = yearKeys.map((year) => ({
    id: year,
    name: year,
    align: TableAlign.Right,
    className: commonClassName,
    getValueForSort: (data) => data.values.find((value) => value.year === year)?.value ?? null,
    renderColumn: (data) => {
      const revenueColValue = data.values.find((value) => value.year === year)
      if (!revenueColValue?.value) return <span className="text-muted-2">—</span>
      return shortFormatNumber(revenueColValue.value)
    },
  }))

  const subColumns: RevenueColumnsType['subColumns'] = {
    [RevenueDataEnum.yoyChange]: yearKeys.map((year) => ({
      id: year,
      name: year,
      align: TableAlign.Right,
      className: commonClassName,
      renderColumn: (data) => {
        const revenueColSubValue = data.values.find((value) => value.year === year)
        return (
          <RedGreenText value={revenueColSubValue?.value} rightContent={null}>
            {shortFormatNumber(revenueColSubValue?.value, { defaultValue: '—' })}
          </RedGreenText>
        )
      },
    })),
    [RevenueDataEnum.yoyChangePct]: yearKeys.map((year) => ({
      id: year,
      name: year,
      align: TableAlign.Right,
      className: commonClassName,
      renderColumn: (data) => {
        const revenueColSubValue = data.values.find((value) => value.year === year)
        return (
          <RedGreenText
            value={revenueColSubValue?.value}
            rightContent={typeof revenueColSubValue?.value === 'number' ? '%' : null}
          >
            {revenueColSubValue?.value?.toFixed(2) ?? '—'}
          </RedGreenText>
        )
      },
    })),
    [RevenueDataEnum.sharePct]: yearKeys.map((year) => ({
      id: year,
      name: year,
      align: TableAlign.Right,
      className: classNames(commonClassName, 'text-muted-2'),
      renderColumn: (data) => {
        const revenueColSubValue = data.values.find((value) => value.year === year)
        if (typeof revenueColSubValue?.value !== 'number') return '-'

        return `${revenueColSubValue.value.toFixed(2)}%`
      },
    })),
  }
  return { columns, subColumns }
}

export function useTableColumns(yearKeys: string[]) {
  return React.useMemo(() => getColumns(yearKeys), [yearKeys])
}
